import { render, staticRenderFns } from "./parts-list.vue?vue&type=template&id=11647e2a"
import script from "./parts-list.vue?vue&type=script&lang=js"
export * from "./parts-list.vue?vue&type=script&lang=js"
import style0 from "./parts-list.vue?vue&type=style&index=0&id=11647e2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Empty: require('/app/components/empty.vue').default,Img: require('/app/components/img.vue').default,ProductPrices: require('/app/components/product/prices.vue').default,Quantity: require('/app/components/quantity.vue').default,Loader: require('/app/components/loader.vue').default,ProductPartsList: require('/app/components/product/parts-list.vue').default})
